import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// Login Redux States
import { REGISTER_USER} from './actionTypes';
import { registerUserFail, registerUserSuccessful, } from './actions';

// AUTH related methods
import { registerApi } from './api';

//If user is login then dispatch redux action's are directly from here.

function* registerUser({ payload }) {
    try {
        const response = yield call(registerApi, payload);
        yield put(registerUserSuccessful(response));
    } catch (error) {
        yield put(registerUserFail(error));
    }
}

function* registerSaga() {
    yield takeEvery(REGISTER_USER, registerUser);
}

export default registerSaga;